import React from 'react';
import ReactEcharts from 'echarts-for-react';
import PropTypes from 'prop-types';

function GraphGroupsPerHourIntegerValues (props) {
  const { members, typeDisplay } = props.el;
  let reports = [];
  const rpts = props.reports.slice();

  if (typeDisplay && typeDisplay !== 'ALL' && members) {
    reports = rpts.filter(rpt => members.includes(rpt._id));
  } else {
    reports = [...rpts];
  }

  const groups = reports.reduce((result, group) => {
    const { name, number, hour, received, answered, lost } = group;
    if (Object.keys(result).includes(number)) {
      result[number].labels = result[number].labels.concat([
        `${hour}\nRCB: ${received}`
      ]);
      result[number].series.answered = result[number].series.answered.concat([
        answered
      ]);
      result[number].series.lost = result[number].series.lost.concat([lost]);
    } else {
      result[number] = {};
      result[number].title = `${number} - ${name}`;
      result[number].labels = [`${hour}\nRCB: ${received}`];
      result[number].series = { answered: [answered], lost: [lost] };
    }
    return result;
  }, {});

  return (
    <div>
      {Object.keys(groups).map((number, i) => {
        const type = 'bar';

        const label = {
          normal: {
            show: true,
            position: 'insideBottom',
            fontSize: 16,
            color: '#000',
            verticalAlign: 'center',
            rotate: 90,
            distance: 30,
            fontWeight: 'bold'
          }
        };

        const configs = {
          title: {
            text: groups[number].title,
            left: 'center',
            textStyle: {
              fontSize: 24,
              fontWeight: 'bold'
            }
          },
          grid: { left: '7%', right: '7%', bottom: '26%' },
          animationDuration: 0,
          hoverAnimation: false,
          cursor: 'default',
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: { top: '12%' },
          xAxis: {
            data: [...groups[number].labels],
            axisLabel: {
              fontSize: 24,
              fontWeight: 'bold'
            }
          },
          yAxis: {
            axisLabel: {
              fontSize: 24,
              fontWeight: 'bold'
            },
            minInterval: groups[number].series.answered.length < 5 ? 1 : 0
          },
          series: [
            {
              name: 'ATD',
              type,
              label,
              color: '#16df23',
              legendHoverLink: false,
              data: [...groups[number].series.answered]
            },
            {
              name: 'PERD',
              type,
              label,
              color: '#da1616',
              data: [...groups[number].series.lost]
            }
          ]
        };
        return <ReactEcharts key={i} option={configs} />;
      })}
    </div>
  );
}

export default GraphGroupsPerHourIntegerValues;

GraphGroupsPerHourIntegerValues.propTypes = {
  el: PropTypes.object,
  reports: PropTypes.array
};
